	'use strict';

angular.module('pulianiBookStoreApp')
  .config(function($stateProvider) {
    $stateProvider
      .state('main', {
        url: '/',
        params: {
        	isAuthorised: null
        },
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      });
  });
